import { useTheme } from '@mui/material';
import DSBox from '../../../../design-system/DSBox';
import DSChip from '../../../../design-system/DSChip';

export type CollectionLabelsProps = {
  labels: string[];
};

const CollectionLabels = ({ labels }: CollectionLabelsProps) => {
  const { spacing } = useTheme();

  if (!labels || labels.length === 0) {
    return null;
  }

  return (
    <DSBox
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: spacing(1.5),
        flexWrap: 'wrap',
      }}
    >
      {labels.map((label, index) => (
        <DSChip key={`${label}-${index}`} label={label} />
      ))}
    </DSBox>
  );
};

export default CollectionLabels;
